<template>
  <div>
  <header style="margin-bottom: 15px;">
    <!-- <el-radio v-model="download_type" :label="1" @input="radioChange"
          >git下载</el-radio
        >
        <el-radio v-model="download_type" :label="2" @input="radioChange"
        v-if="projectWangpanUrl.url != '' ">网盘下载</el-radio
        > -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="Git下载" name="first">
      <div style="justify-content: center; align-items: center;  display: flex; position: relative;" v-show="download_type==1">
        <div style="width: 100%;  margin-top: 10px; background: #ddd; padding: 10px; font-size: 13px;  overflow: hidden; " >
          <markdown-render :markdown="markdownContent" code-block-class="custom-style"></markdown-render>
           <i :data-clipboard-text="`git clone ${modelInfo.project_git_url}.git`"
        class="el-icon-document-copy copy-link cursor-pointer mx-10px" style="position: absolute; top:65%; right: 30px;"></i>
        <i :data-clipboard-text="`git lfs install`"
        class="el-icon-document-copy copy-link cursor-pointer mx-10px" style="position: absolute; top:35%; right: 30px;"></i>
        </div>
    </div>
    </el-tab-pane>
    <el-tab-pane label="网盘下载" name="second" v-if="projectWangpanUrl.url != ''">

    <div style="justify-content: center; align-items: center;  display: flex;" v-if="projectWangpanUrl.url != ''">
     
       <div style="width: 100%;  margin-top: 10px; background: #ddd; padding: 10px; font-size: 13px; position: relative;">
         <markdown-render :markdown="projectWangpanUrl.url" code-block-class="custom-style" ></markdown-render>
          <i :data-clipboard-text="`${projectWangpanUrl.url}`"
       class="el-icon-document-copy copy-link cursor-pointer mx-10px" style="position: absolute; top:15px; right: 30px;"></i>
       </div>
   
   </div>
    
    </el-tab-pane>
  </el-tabs>
  </header>
   


  
  </div>
</template>

<script>
import MarkdownRender from '@/components/MarkdownRender.vue';
export default {
  created(){
    this.markdownContent=`   \ngit lfs install #请确保您已经安装 git-lfs (https://git-lfs.com)  \n git clone `+`${this.modelInfo.project_git_url}`+`.git`
   
  },
  components: {
    MarkdownRender
  },
  props: { modelInfo: {}, projectWangpanUrl: {} },
  data() {
    return {
      activeName:'first',
      markdownContent:'' ,// Markdown文本
      download_type:1, //下载方式
      gitlfs:'#请确保您已经安装 git-lfs install (https://git-lfs.com)  \ngit lfs install'
    }
  },
  computed: {

  },


  mounted() { },
  methods: {
    jump(){
      this.$router.push({
        path: '/docs/模型下载'
      })
    },
    handleClick(){

    },
    //下载方式切换
    radioChange(){
     
    },
    //重置选项
    ResetType(){
      this.download_type=1
    }

  }
}

</script>
<style lang="scss" scoped>

.el-form .el-form-item__content {
  overflow-x: hidden;
}

::v-deep(.custom-code-block){
  background: #fff;
}

::v-deep(p){
  white-space: nowrap; 
  overflow-x: auto;
}
.el-form .el-form-item__content .el-radio {
  line-height: 0;
}
.el-form .el-form-item__content {
  margin-left: 0 !important;
}

::v-deep(.el-tabs__header .el-tabs__item){
  text-align: center;
  font-size: 0.13rem;
  width: 0.6rem !important;
}


</style>
